import {API_ENDPOINTS, LoadingKeys} from '@/constants';
import {IChangeReviewStatus, IReviewItem, IReviewsParams, ListResponse,} from '@/models';
import {changeEnabledStatus, http, updateItemById} from '@/utils';

import {AxiosRequestConfig} from 'axios';
import {create} from 'zustand';
import {handleApiCallInStore} from './utils';
import {persist} from 'zustand/middleware';
import {t} from 'i18next';

export interface IReviewsStore {
  reviews: IReviewItem[];
  nbHits: number;
  getReviews: (params: IReviewsParams) => void;
  changeReviewStatus: (payload: IChangeReviewStatus) => void;
}

export const useReviewsStore = create(
  persist<IReviewsStore>(
    set => ({
      reviews: [],
      nbHits: 0,
      getReviews: async params => {
        handleApiCallInStore(LoadingKeys.ReviewsList, async () => {
          const {data} = await http.get<ListResponse<IReviewItem>>(
            API_ENDPOINTS.reviews,
            {params} as AxiosRequestConfig
          );
          set(() => ({reviews: data.items ?? [], nbHits: data?.nbHits ?? 0}));
        });
      },
      changeReviewStatus: async payload => {
        handleApiCallInStore(LoadingKeys.ChangeReviewStatus, async () => {
          const {experienceID, objectID, isEnabled} = payload;
          await http.put(
            `${API_ENDPOINTS.reviews}/${experienceID}/${objectID}/deactivate`,
            {isEnabled}
          );
          set(({reviews}) => ({
            reviews: updateItemById(reviews, 'isEnabled', isEnabled, objectID),
          }));
          changeEnabledStatus(isEnabled, t('review'));
        });
      },
    }),
    {
      name: 'coaches-storage',

    }
  )
);
